import React from 'react';

import ExtensionContactAvatar from 'flow/components/ui-components/ExtensionContactAvatar';
import ExtensionName from 'flow/components/ui-components/ExtensionName';
import { ExtensionKey } from 'flow/types/EntityKeys';

interface Props {
    extensionKey: ExtensionKey;
}

/** One colleague the ticket can be opened to. */
const AccessCandidateItem = ({ extensionKey }: Props) => (
    <div className="flex items-center gap-x-2 px-3 py-2 text-sm text-gray-800">
        <ExtensionContactAvatar
            extensionKey={extensionKey}
            size="small"
            lazyLoad={true}
        />
        <span className="flex-1 truncate">
            <ExtensionName extensionKey={extensionKey} />
        </span>
    </div>
);

export default React.memo(AccessCandidateItem);
